<template>
  <div class="main-content">
    <preloader v-if="preloader" :message="preloaderText" />

    <div class="terminal-wrapper" v-if="preloader && $store.state.serverLogs && $store.state.serverLogs.length > 0">
      <div class="terminal-container">
        <div class="terminal-header">
          <span class="dot red"></span>
          <span class="dot yellow"></span>
          <span class="dot green"></span>
          <span class="title">TM Parser Logs</span>
        </div>
        <div class="terminal-body" ref="terminalBody">
          <div v-for="(log, index) in $store.state.serverLogs" :key="index" class="log-line">
            <span class="arrow">></span> {{ log }}
          </div>
          <div class="log-line blink"><span class="arrow">></span> _</div>
        </div>
      </div>
    </div>

    <div v-if="matchdayHtml && matchdayHtml.length > 0" class="tm-table-container">
      <div class="tm-header">
        <button @click="selectAllMatches" class="select-all-btn">
          ☑️ {{ isAllCurrentSelected ? 'Снять выделение' : 'Выбрать все (Текущий тур)' }}
        </button>

        <button v-if="nextMatches.length > 0" @click="selectAllNextMatches" class="select-all-btn next-btn">
          📅 {{ isAllNextSelected ? 'Снять (Будущие)' : 'Выбрать все (Будущие)' }}
        </button>
        
        <button @click="parseSelectedMatches" class="go-batch-btn" :disabled="selectedMatches.length === 0">
          🚀 Парсить выбранные ({{ selectedMatches.length }})
        </button>
        <button @click="closeTable" class="close-btn">
          ❌ Закрыть таблицу
        </button>
      </div>
      
      <table class="table table-hover mt-2 custom-tm-table">
        <thead class="thead-light">
          <tr>
            <th class="text-center col-date">Дата / Время / Стадия</th>
            <th class="text-right col-home">Хозяева</th>
            <th class="text-center col-score">Счет</th>
            <th class="text-left col-away">Гости</th>
            <th class="text-center col-action">Действие</th>
            <th class="text-center col-cb">☑️</th>
          </tr>
        </thead>
        <tbody>
          
          <tr v-for="(match, index) in currentMatches" :key="'current-'+index">
            <td class="text-center align-middle match-date">{{ match.date }}</td>
            <td class="text-right font-weight-bold align-middle">{{ match.homeTeam }}</td>
            <td class="text-center align-middle">
             <span class="match-score">{{ formatLocalTime(match.date, match.score) }}</span>
           </td>
            <td class="text-left font-weight-bold align-middle">{{ match.awayTeam }}</td>
            <td class="text-center align-middle">
              <button class="btn btn-success parse-single-btn" @click="parseSingleMatch(match.link)">GO</button>
            </td>
            <td class="text-center align-middle">
              <input type="checkbox" :value="match.link" v-model="selectedMatches" class="batch-parse-cb" />
            </td>
          </tr>

          <tr v-if="nextMatches.length > 0" @click="showNext = !showNext" class="played-divider next-divider">
            <td colspan="6" class="p-0">
              <div class="divider-flex-container">
                <div class="flex-spacer-left"></div>
                <div class="divider-content">
                  {{ showNext ? 'Скрыть будущие матчи' : 'Показать будущие матчи (Next Matchday)' }} ({{ nextMatches.length }})
                  <span class="divider-arrow">{{ showNext ? '▲' : '▼' }}</span>
                </div>
                <div class="flex-spacer-right"></div>
              </div>
            </td>
          </tr>

          <template v-if="showNext">
            <tr v-for="(match, index) in nextMatches" :key="'next-'+index" class="next-row">
              <td class="text-center align-middle match-date">{{ match.date }}</td>
              <td class="text-right font-weight-bold align-middle">{{ match.homeTeam }}</td>
              <td class="text-center align-middle">
               <span class="match-score">{{ formatLocalTime(match.date, match.score) }}</span>
              </td>
              <td class="text-left font-weight-bold align-middle">{{ match.awayTeam }}</td>
              <td class="text-center align-middle">
                <button class="btn btn-success parse-single-btn" @click="parseSingleMatch(match.link)">GO</button>
              </td>
              <td class="text-center align-middle">
                <input type="checkbox" :value="match.link" v-model="selectedMatches" class="batch-parse-cb" />
              </td>
            </tr>
          </template>

          <tr v-if="playedMatches.length > 0" @click="showPlayed = !showPlayed" class="played-divider">
            <td colspan="6" class="p-0">
              <div class="divider-flex-container">
                <div class="flex-spacer-left"></div>
                <div class="divider-content">
                  {{ showPlayed ? 'Скрыть' : 'Показать сыгранные матчи' }} ({{ playedMatches.length }})
                  <span class="divider-arrow">{{ showPlayed ? '▲' : '▼' }}</span>
                </div>
                <div class="flex-spacer-right"></div>
              </div>
            </td>
          </tr>

          <template v-if="showPlayed">
            <tr v-for="(match, index) in playedMatches" :key="'played-'+index" class="played-row">
              <td class="text-center align-middle match-date">{{ match.date }}</td>
              <td class="text-right font-weight-bold align-middle">{{ match.homeTeam }}</td>
              <td class="text-center align-middle">
               <span class="match-score">{{ formatLocalTime(match.date, match.score) }}</span>
              </td>
              <td class="text-left font-weight-bold align-middle">{{ match.awayTeam }}</td>
              <td class="text-center align-middle">
                <button class="btn btn-success parse-single-btn" @click="parseSingleMatch(match.link)">GO</button>
              </td>
              <td class="text-center align-middle">
                <input type="checkbox" :value="match.link" v-model="selectedMatches" class="batch-parse-cb" />
              </td>
            </tr>
          </template>

        </tbody>
      </table>
    </div>
    
    <div v-else-if="matchdayHtml && matchdayHtml.error" class="alert alert-danger mt-3 m-4">
      {{ matchdayHtml.error }}
      <button @click="closeTable" class="btn btn-sm btn-outline-danger ml-3">Закрыть</button>
    </div>

    <div ref="captureArea" style="background-color: white;">
      <two_lineup
        v-if="(!isEmptyObject(matches.teamA) && !preloader) || (!isEmptyObject(matches.teamB) && !preloader)"
        @clearSavedColor="clearSavedColor($event)"
        @clearSavedLU="clearSavedLU($event)"
        @clearSavedStatus="clearSavedStatus($event)"
        :matchCount="matchCount"
      />
    </div>
  </div>
</template>

<script>
import preloader from "@/components/preloader";
import two_lineup from "@/components/two_lineup";
import * as htmlToImage from 'html-to-image'; 

export default {
  name: "home",
  components: { two_lineup, preloader },
  data() {
    return {
      selectedMatches: [], 
      showPlayed: false,
      showNext: false,
      svgSizedCache: {}
    };
  },
  created() { this.$root.$on('request-screenshot', this.copyScreenshot); },
  beforeDestroy() { this.$root.$off('request-screenshot', this.copyScreenshot); },
  watch: {
    // === НОВЫЙ ВОТЧЕР ДЛЯ ТЕРМИНАЛА ===
    // Следим за обновлением массива логов и скроллим вниз
    '$store.state.serverLogs'() {
      this.$nextTick(() => {
        const terminal = this.$refs.terminalBody;
        if (terminal) {
          terminal.scrollTop = terminal.scrollHeight;
        }
      });
    }
  },
  methods: {
    // Флаги и логотипы лежат на доменах ТМ, а они не отдают CORS-заголовков:
    // браузер запрещает вшивать такие картинки в холст, и снимок падал целиком.
    // На время съёмки подменяем их адреса на свой эндпоинт — для браузера это
    // уже своя картинка. Возвращает список [элемент, исходный адрес] для отката.
    async proxyImagesForCapture(root) {
      const swapped = [];

      root.querySelectorAll('img').forEach(img => {
        const src = img.getAttribute('src');
        if (!src) return;
        let absolute;
        try {
          absolute = new URL(src, location.href);
        } catch (e) {
          return;
        }
        if (absolute.origin === location.origin) return;

        // Мелкие иконки (кружки, вопросик) сборщик вшивает прямо в код адресом
        // data:. У такого адреса origin равен null, то есть «чужой», и они уходили
        // в прокси для картинок ТМ — тот их не отдаёт, и значки пропадали из кадра
        if (absolute.protocol === 'data:' || absolute.protocol === 'blob:') return;

        swapped.push([img, src]);
        img.setAttribute('src', `/api/tm/img?url=${encodeURIComponent(absolute.href)}`);
      });

      // Ждём, пока подменённые картинки загрузятся, иначе они не попадут в снимок
      await Promise.all(swapped.map(([img]) => new Promise(resolve => {
        if (img.complete) return resolve();
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
        setTimeout(resolve, 8000);
      })));

      return swapped;
    },

    // Иконки (самолётик, плюсик, список, корзина) — это SVG, где прописан только
    // viewBox. html2canvas берёт у картинки её собственный размер (naturalWidth) и
    // этим прямоугольником вырезает кусок из файла: у SVG без размеров Chrome даёт
    // 300x150, поэтому в кадр попадал обрезанный угол иконки — чёрная чёрточка
    // вместо списка, красный огрызок вместо самолётика. Разметкой это не лечится,
    // размеры читаются из самого файла. Поэтому на время съёмки переводим иконки
    // в PNG: рисуем через drawImage целиком, без вырезания, а у растра собственный
    // размер есть всегда.
    async prepareSvgIconsForCapture(root) {
      const swapped = [];
      const images = Array.from(root.querySelectorAll('img')).filter((img) => {
        const src = img.getAttribute('src') || '';
        return /\.svg(\?|$)/i.test(src) || src.startsWith('data:image/svg+xml');
      });

      for (const img of images) {
        const rect = img.getBoundingClientRect();
        if (!rect.width || !rect.height) continue;

        // Вдвое крупнее видимого: холст потом ужмёт, зато иконка не мылит
        const width = Math.round(rect.width * 2);
        const height = Math.round(rect.height * 2);
        const src = img.getAttribute('src');

        const png = await this.svgToPng(src, width, height);
        if (!png) continue;

        swapped.push([img, src]);
        img.setAttribute('src', png);

        await new Promise((resolve) => {
          if (img.complete) return resolve();
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
          setTimeout(resolve, 2000);
        });
      }

      console.log(`📸 иконок переведено в растр: ${swapped.length}`);
      return swapped;
    },

    // Файлов иконок всего несколько, а картинок с ними на экране сотни — держим кэш
    svgToPng(src, width, height) {
      const key = `${src}|${width}x${height}`;
      if (this.svgSizedCache[key]) return Promise.resolve(this.svgSizedCache[key]);

      return new Promise((resolve) => {
        const image = new Image();

        image.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            // Пять аргументов: масштабируем картинку ЦЕЛИКОМ. Это и есть суть
            // правки — никакого прямоугольника-источника, нечему обрезаться
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            const png = canvas.toDataURL('image/png');
            this.svgSizedCache[key] = png;
            resolve(png);
          } catch (e) {
            console.warn('Иконку не удалось перевести в растр:', src, e && e.message);
            resolve(null);
          }
        };

        image.onerror = () => resolve(null);
        setTimeout(() => resolve(null), 3000);
        image.src = src;
      });
    },

    // Что в кадр не идёт: кнопки, поля, ползунки, подвал и строки, спрятанные
    // глазиком. Скрытые строки в снимок и так не попадали, но их клонирование и
    // расчёт стилей — самая дорогая часть съёмки
    skipInShot(node) {
      const tag = node.tagName ? node.tagName.toLowerCase() : '';
      if (tag === 'button' || tag === 'input' || tag === 'svg') return true;
      if (node.style && node.style.display === 'none') return true;
      if (node.classList) {
        if (node.classList.contains('footer') ||
            node.classList.contains('add_player') ||
            node.classList.contains('vue-slider')) {
          return true;
        }
      }
      return false;
    },

    async shotByHtml2Canvas(element) {
      const html2canvas = (await import('html2canvas')).default;
      const rect = element.getBoundingClientRect();
      const canvas = await html2canvas(element, {
        backgroundColor: '#ffffff',
        scale: 1,
        logging: false,
        // Картинки ТМ на время съёмки уже подменены на свой эндпоинт,
        // так что холст не «пачкается» и toBlob отработает
        useCORS: true,
        ignoreElements: (node) => this.skipInShot(node)
      });

      // html2canvas снимает не сам узел, а его клон в отдельном документе, куда
      // переносит таблицы стилей. Когда перенос не удался, клон верстается голым
      // HTML: две колонки складываются в узкую простыню на всю высоту. Ловим это
      // по ширине — снимок без стилей заметно уже настоящей таблицы
      if (rect.width > 0 && canvas.width < rect.width * 0.6) {
        throw new Error(`снимок без стилей: ${canvas.width} px при таблице ${Math.round(rect.width)} px`);
      }

      return new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    },

    async shotByHtmlToImage(element) {
      return htmlToImage.toBlob(element, {
        backgroundColor: '#ffffff',
        skipFonts: true,
        pixelRatio: 1,
        filter: (node) => (node.nodeType === 3 ? true : !this.skipInShot(node)),
        style: { margin: '0' }
      });
    },

    async copyScreenshot() {
      // Переменная для хранения картинки на случай непредвиденной ошибки
      let generatedBlob = null;
      let swappedImages = [];

      // Замер по этапам: нужно понять, где уходит время — на картинки или на отрисовку
      const tStart = performance.now();
      const ms = (from) => Math.round(performance.now() - from);
      let tImages = 0;
      let tRender = 0;

      try {
        // 1. Создаем "Обещание" (Promise), что картинка будет создана.
        const blobPromise = new Promise(async (resolve, reject) => {
          try {
            let element = this.$refs.captureArea.querySelector('.lineups_body');
            if (!element) { element = this.$refs.captureArea; }

            element.classList.add('screenshot-mode');

            const commentsDivs = element.querySelectorAll('.comments');
            commentsDivs.forEach(div => div.removeAttribute('data-html2canvas-ignore'));

            // Даем браузеру долю секунды на перестроение сетки
            await this.$nextTick();
            await new Promise(r => setTimeout(r, 50));

            // Шрифты дожидаемся отдельно: если они ещё грузятся, клон снимается
            // раньше времени и приезжает без оформления
            if (document.fonts && document.fonts.ready) {
              try {
                await document.fonts.ready;
              } catch (e) {
                console.warn('📸 шрифты не дождались:', e && e.message);
              }
            }

            const tImagesStart = performance.now();
            swappedImages = await this.proxyImagesForCapture(element);
            tImages = ms(tImagesStart);
            console.log(`📸 картинки: ${tImages} мс, подменено ${swappedImages.length} шт.`);

            const totalNodes = element.querySelectorAll('*').length;
            const hiddenNodes = Array.from(element.querySelectorAll('*'))
              .filter(n => n.style && n.style.display === 'none').length;
            console.log(`📸 узлов в таблице: ${totalNodes}, из них скрытых: ${hiddenNodes}`);

            // Иконки готовим после подмены картинок ТМ: обе правки откатываются
            // из одного списка
            swappedImages = swappedImages.concat(await this.prepareSvgIconsForCapture(element));

            const tRenderStart = performance.now();

            // Снимок делает html2canvas: на живой таблице она втрое быстрее
            // html-to-image (825 мс против 2712 при 1915 узлах). Старая
            // библиотека осталась запасной на случай, если html2canvas где-то
            // нарисует не то: localStorage.shotLib = 'html-to-image'
            let blob;
            if (localStorage.getItem('shotLib') === 'html-to-image') {
              blob = await this.shotByHtmlToImage(element);
            } else {
              try {
                blob = await this.shotByHtml2Canvas(element);
              } catch (err) {
                // Не роняем съёмку: html-to-image медленнее, зато стили переносит иначе
                console.warn('📸 html2canvas не справилась, снимаем запасной:', err && err.message);
                blob = await this.shotByHtmlToImage(element);
              }
            }

            tRender = ms(tRenderStart);
            console.log(`📸 отрисовка холста: ${tRender} мс`);

            // Сравнение со старой библиотекой: localStorage.benchShot = 1
            if (localStorage.getItem('benchShot')) {
              try {
                const t2 = performance.now();
                await this.shotByHtmlToImage(element);
                console.log(`📸 [сравнение] html-to-image: ${ms(t2)} мс`);
              } catch (e) {
                console.warn('📸 [сравнение] html-to-image не смогла:', e && e.message);
              }
            }

            // Возвращаем стили обратно
            element.classList.remove('screenshot-mode');
            commentsDivs.forEach(div => div.setAttribute('data-html2canvas-ignore', 'true'));

            if (blob) {
              generatedBlob = blob; // Сохраняем на всякий случай
              resolve(blob);        // 🚀 Отдаем готовую картинку в буфер!
            } else {
              reject(new Error("Blob получился пустым"));
            }
          } catch (err) {
            // Если что-то сломалось, подчищаем за собой
            let element = this.$refs.captureArea.querySelector('.lineups_body');
            if (element) element.classList.remove('screenshot-mode');
            reject(err);
          }
        });

        // 2. МГНОВЕННО обращаемся к буферу обмена!
        const item = new ClipboardItem({ "image/png": blobPromise });
        await navigator.clipboard.write([item]);

        console.log("✅ Скриншот успешно скопирован в фоне!");
        console.log(`📸 ИТОГО: ${ms(tStart)} мс (картинки ${tImages}, холст ${tRender}, остальное ${ms(tStart) - tImages - tRender})`);

      } catch (error) {
        console.error("Ошибка буфера обмена: ", error);
        // Срабатывает запасной план (открытие в новой ссылке) только если всё реально сломалось
        if (generatedBlob) {
          const url = URL.createObjectURL(generatedBlob);
          window.open(url, '_blank');
        } else {
          const reason = (error && (error.message || error.name)) || 'причина неизвестна';
          alert(`Не удалось сделать скриншот: ${reason}\n\nПодробности в консоли браузера (F12).`);
        }
      } finally {
        // Возвращаем картинкам их родные адреса, что бы ни случилось
        swappedImages.forEach(([img, src]) => img.setAttribute('src', src));
      }
    },
    closeTable() { this.$store.commit('SET_MATCHDAY_HTML', null); this.selectedMatches = []; this.showPlayed = false; this.showNext = false; },
    isPlayed(score) { if (!score) return false; const s = score.toUpperCase(); if (s.includes('PM') || s.includes('AM') || s.includes('-:-') || s.includes('POSTP') || s.includes('CANC')) return false; return /\d+:\d+/.test(s); },
    formatLocalTime(dateStr, timeStr) {
      if (!timeStr || (!timeStr.toUpperCase().includes('AM') && !timeStr.toUpperCase().includes('PM'))) return timeStr;
      try {
        let [time, modifier] = timeStr.trim().split(' ');
        let [hours, minutes] = time.split(':');
        hours = parseInt(hours, 10);
        if (hours === 12 && modifier.toUpperCase() === 'AM') hours = 0;
        if (hours < 12 && modifier.toUpperCase() === 'PM') hours += 12;
        let dateMatch = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})/);
        if (!dateMatch) return timeStr;
        let d = new Date(Date.UTC(dateMatch[3], dateMatch[2]-1, dateMatch[1], hours - 2, minutes));
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      } catch (e) { return timeStr; }
    },
    selectAllMatches() {
      if (this.currentMatches.length === 0) return;
      if (this.isAllCurrentSelected) {
        this.selectedMatches = this.selectedMatches.filter(link => !this.currentMatches.some(m => m.link === link));
      } else {
        const newSelection = new Set(this.selectedMatches);
        this.currentMatches.forEach(m => newSelection.add(m.link));
        this.selectedMatches = Array.from(newSelection);
      }
    },
    selectAllNextMatches() {
      if (this.nextMatches.length === 0) return;
      if (this.isAllNextSelected) {
        this.selectedMatches = this.selectedMatches.filter(link => !this.nextMatches.some(m => m.link === link));
      } else {
        const newSelection = new Set(this.selectedMatches);
        this.nextMatches.forEach(m => newSelection.add(m.link));
        this.selectedMatches = Array.from(newSelection);
        this.showNext = true; 
      }
    },
    async parseSingleMatch(matchUrl) { 
      this.closeTable(); 
      try { 
        const parsedMatch = await this.$store.dispatch("PARSE_URL", { url: matchUrl, team: "match" }); 
        document.title = `${parsedMatch.teamA.name} - ${parsedMatch.teamB.name}`; 
        await this.$store.dispatch("ADD_SAVED_MATCHES", { ...parsedMatch }); 
        await this.$store.dispatch("GET_SAVED_COLOR"); 
      } catch (error) { 
        console.error(error); 
      } 
    },
    async parseSelectedMatches() {
      if (this.selectedMatches.length === 0) return;
      const urlsToParse = [...this.selectedMatches];
      this.closeTable();
      const startTime = performance.now();
      for (const url of urlsToParse) {
        try {
          const parsedMatch = await this.$store.dispatch("PARSE_URL", { url: url, team: "match" });
          if (parsedMatch) {
            await this.$store.dispatch("ADD_SAVED_MATCHES", { ...parsedMatch });
          }
        } catch (error) {
          console.error(`Ошибка при парсинге матча ${url}:`, error);
        }
      }
      await this.$store.dispatch("GET_SAVED_COLOR");
      const endTime = performance.now();
      const totalSeconds = ((endTime - startTime) / 1000).toFixed(1);
      alert(`Матчи (${urlsToParse.length}) загружены!\nЗатрачено: ${totalSeconds} сек.`);
    },
    clearSavedColor(id) { this.$store.dispatch("CLEAR_SAVED_COLOR", id).then(() => this.$store.dispatch("GET_SAVED_COLOR")); },
    clearSavedLU(id) { this.$store.dispatch("CLEAR_SAVED_LU", id).then(() => this.$store.dispatch("GET_SAVED_COLOR")); },
    clearSavedStatus(id) { this.$store.dispatch("CLEAR_SAVED_STATUS", id).then(() => this.$store.dispatch("GET_SAVED_COLOR")); },
    isEmptyObject(obj) { return obj && Object.keys(obj).length === 0 && obj.constructor === Object; }
  },
  computed: {
    matches() { return this.$store.getters.matches; },
    preloader() { return this.$store.getters.preloader; },
    preloaderText() { return this.$store.getters.preloaderText; },
    matchCount() { return this.$store.getters.matchCount; },
    matchdayHtml() { return this.$store.getters.matchdayHtml; },
    currentMatches() { if (!this.matchdayHtml || !Array.isArray(this.matchdayHtml)) return []; return this.matchdayHtml.filter(m => !this.isPlayed(m.score) && !m.isNextMatchday); },
    nextMatches() { if (!this.matchdayHtml || !Array.isArray(this.matchdayHtml)) return []; return this.matchdayHtml.filter(m => !this.isPlayed(m.score) && m.isNextMatchday); },
    playedMatches() { if (!this.matchdayHtml || !Array.isArray(this.matchdayHtml)) return []; return this.matchdayHtml.filter(m => this.isPlayed(m.score)); },
    isAllCurrentSelected() { if (this.currentMatches.length === 0) return false; const currentSelected = this.selectedMatches.filter(link => this.currentMatches.some(m => m.link === link)); return currentSelected.length === this.currentMatches.length; },
    isAllNextSelected() { if (this.nextMatches.length === 0) return false; const nextSelected = this.selectedMatches.filter(link => this.nextMatches.some(m => m.link === link)); return nextSelected.length === this.nextMatches.length; }
  }
};
</script>

<style scoped>
/* ТВОИ ОРИГИНАЛЬНЫЕ СТИЛИ ДЛЯ ТАБЛИЦЫ */
.tm-table-container { 
  background: #fff; border-radius: 8px; padding: 18px 22px; margin: 20px auto; max-width: 1100px; box-shadow: 0 4px 15px rgba(0,0,0,0.1); 
}
.tm-header { display: flex; justify-content: flex-end; gap: 16px; margin-bottom: 12px; }
.custom-tm-table { background-color: white; border: 1px solid #dee2e6; font-size: 14.5px; width: 100%; border-collapse: collapse; }

.col-date { width: 18%; }
.col-home { width: 22%; }
.col-score { width: 100px; }
.col-away { width: 22%; }
.col-action { width: 80px; }
.col-cb { width: 60px; }

.match-date { color: #666; white-space: nowrap; }
.match-score { background-color: #e9ecef; color: #005f90; padding: 3px 10px; border-radius: 4px; font-weight: bold; display: inline-block; min-width: 65px; }

.divider-flex-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
}
.flex-spacer-left {
  flex: 0 0 40%;
}
.divider-content {
  flex: 0 0 100px; 
  text-align: center;
  white-space: nowrap;
  font-weight: 600;
  padding: 0 10px;
}
.flex-spacer-right {
  flex: 1;
}

.played-divider td {
  background-color: #f1f3f5 !important; color: #495057; cursor: pointer; border-top: 1px solid #dee2e6; border-bottom: 1px solid #dee2e6;
}
.played-divider:hover td { background-color: #e2e6ea !important; }

.next-divider td { background-color: #e9f2fb !important; color: #004085; }
.next-divider:hover td { background-color: #d6e8fa !important; }

.divider-arrow { font-size: 12px; margin-left: 6px; }
.batch-parse-cb { transform: scale(1.3); cursor: pointer; }
.parse-single-btn { font-weight: bold; padding: 3px 14px; font-size: 12px; }
.select-all-btn { background: #007bff; color: white; border: none; padding: 6px 14px; border-radius: 4px; font-size: 13.5px; cursor: pointer; }
.next-btn { background: #17a2b8; } 
.go-batch-btn { background: #28a745; color: white; border: none; padding: 6px 14px; border-radius: 4px; font-size: 13.5px; cursor: pointer; }
.close-btn { background: #dc3545; color: white; border: none; padding: 6px 14px; border-radius: 4px; font-size: 13.5px; cursor: pointer; }

/* === НОВЫЕ СТИЛИ ДЛЯ ТЕРМИНАЛА === */
.terminal-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px; /* Отступ вниз от слова Загрузка */
  margin-bottom: 20px; 
  z-index: 10000;
  pointer-events: none; /* Пропускаем клики сквозь контейнер */
}

.terminal-container {
  pointer-events: auto; 
  width: 600px;
  max-width: 90vw;
  background: #1e1e1e;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  font-family: 'Courier New', Courier, monospace;
  
  /*  Запрет выделения и копирования */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default; /* Убирает "палочку" для ввода текста */
}

.terminal-header {
  background: #2d2d2d;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #000;
}

.terminal-header .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
}

.dot.red { background: #ff5f56; }
.dot.yellow { background: #ffbd2e; }
.dot.green { background: #27c93f; }

.terminal-header .title {
  color: #999;
  font-size: 12px;
  margin-left: 15px;
  font-weight: bold;
}

.terminal-body {
  padding: 15px;
  height: 200px; 
  overflow-y: auto; 
  text-align: left;
}

.log-line {
  color: #a5d6ff; 
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 4px;
  word-break: break-all;
}

.log-line .arrow {
  color: #27c93f; 
  margin-right: 8px;
  font-weight: bold;
}

.blink {
  animation: blinker 1s step-start infinite;
  color: #fff;
}

@keyframes blinker {
  50% { opacity: 0; }
}

.terminal-body::-webkit-scrollbar {
  width: 8px;
}
.terminal-body::-webkit-scrollbar-track {
  background: #1e1e1e;
}
.terminal-body::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}
</style>

<style>
/* === ИДЕАЛЬНЫЕ СТИЛИ (ТЕРМОУСАДКА БЛОКА + КОММЕНТАРИИ) === */

/* ПРИМЕНЯЕТСЯ ПРЯМО К .lineups_body, плотно обхватывая контент */
.lineups_body.screenshot-mode {
  display: inline-flex !important; /* Блок становится ровно по ширине таблиц */
  flex-direction: row !important;
  flex-wrap: nowrap !important; /* Запрет падения вниз */
  width: max-content !important;
  background-color: white !important;
  padding: 10px !important; /* Аккуратная белая рамка вокруг скрина */
  gap: 20px !important; /* Отступ между командами */
}

.screenshot-mode .squadTable {
  width: max-content !important;
  flex: none !important;
}

/* Оформляем блок комментариев (он лежит прямо под формой/статой) */
.screenshot-mode .comments {
  display: block !important;
  width: 100% !important;
  padding: 10px 0 !important;
  box-sizing: border-box !important;
}

.screenshot-mode textarea {
  width: 100% !important;
  height: 60px !important;
  border: 1px solid #ccc !important;
  border-radius: 4px !important;
  resize: none !important;
  background-color: #f9f9f9 !important;
  padding: 8px !important;
  box-sizing: border-box !important;
  color: #333 !important;
  font-family: inherit !important;
  overflow: hidden !important;
}

/* Скрываем всё лишнее (подвал, чекбоксы, корзины) */
.screenshot-mode .footer,
.screenshot-mode input,
.screenshot-mode button,
.screenshot-mode .btn,
.screenshot-mode svg,
.screenshot-mode .vue-slider,
.screenshot-mode .vue-slider-component,
.screenshot-mode [class*="slider"],
.screenshot-mode [class*="control"],
.screenshot-mode .screenshot-hidden,
.screenshot-mode .add_player {
  display: none !important;
}

/* Зачёркнутые имена ушедших. Правило line-through висит на внешнем блоке
   (.red_text), а само имя лежит во вложенном span — браузер такую линию рисует,
   а html2canvas смотрит только на тот элемент, в котором лежит текст, и линии
   не было. На время съёмки дублируем зачёркивание на потомков */
.screenshot-mode .red_text,
.screenshot-mode .red_text * {
  text-decoration: line-through !important;
}

/* Окошко вставки картинки состава в кадр не нужно. Прячем через visibility,
   а не display: у неадминов на его месте распорка в те же 90px, и с display:none
   шапка таблицы в снимке съезжала бы относительно того, что видно на экране */
.screenshot-mode .ocr-paste {
  visibility: hidden !important;
}
</style>